import { render, staticRenderFns } from "./TableFloatingFilter.vue?vue&type=template&id=b4640476&scoped=true&"
import script from "./TableFloatingFilter.vue?vue&type=script&lang=js&"
export * from "./TableFloatingFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4640476",
  null
  
)

export default component.exports